<template>
  <div class="product-hero-carousel">
    <agile
      ref="main"
      :as-nav-for="asNavFor1"
      :options="options1"
      class="main-carousel"
    >
      <template
        slot="prevButton"
        type="div"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="7.895"
          />
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="42.105"
          />
        </svg>
      </template>
      <template
        slot="nextButton"
        title="Next Slide"
        alt="Next Slide"
        aria-label="Next Slide"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="7.895"
            x2="33.382"
            y2="25"
          />
          <line
            class="ls"
            x1="16.618"
            y1="42.105"
            x2="33.382"
            y2="25"
          />
        </svg>
      </template>

      <div
        v-for="(item, imageIndex) in items"
        :key="imageIndex"
        class="slide feature-slide"
      >
        <ProductHero :content="item" />
      </div>
    </agile>
    <agile
      ref="thumbnails"
      :as-nav-for="asNavFor2"
      :options="options2"
      class="navigation-carousel"
    >
      <template
        slot="prevButton"
        type="div"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="7.895"
          />
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="42.105"
          />
        </svg>
      </template>
      <template
        slot="nextButton"
        title="Next Slide"
        alt="Next Slide"
        aria-label="Next Slide"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="7.895"
            x2="33.382"
            y2="25"
          />
          <line
            class="ls"
            x1="16.618"
            y1="42.105"
            x2="33.382"
            y2="25"
          />
        </svg>
      </template>
      <div
        v-for="(item, imageIndex) in items"
        :key="imageIndex"
        class="slide slide-thumbnail"
        :title="item.author"
        @click="$refs.thumbnails.goTo(imageIndex)"
      >
        <div class="slide-inner">
          <div class="bottle-image-container">
            <img
              :src="item.thumbnail.fileStore.presignedURL"
              class="bottle-image"
            >
          </div>
        </div>
      </div>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import ProductHero from './product-hero.vue'

export default {
  name: 'product-hero-carousel',
  components: {
    ProductHero,
    agile: VueAgile
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // agile slider
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        fade: true,
        dots: false,
        navButtons: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 17500
      },
      options2: {
        navButtons: false,
        dots: false,
        slidesToShow: 3,
        infinite: true,
        navButtons: false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3
            }
          },

          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  },

  mounted() {
    // const items = require("./lib/items");
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  }
}
</script>

  <style lang="scss" scoped>
  @import '~@scss/custom.scss';
  .product-hero-carousel  {
    --hero-arrow-color:#000;
  }

  .agile__slide {
    height: 100%;
  }

  .navigation-carousel {
    padding-top: 0em;
    margin: 0 auto;
    max-width:10em;
    @include media-breakpoint-up(lg) {
      width: 10em;
    }
    .bottle-image-container {
      width: 3em;
      height: 6em;
      overflow: hidden;
      z-index: 1;
      img {
        position: relative;
        z-index: -1;
        object-fit: contain;
        object-position: center;
        width: 100%;
        height: 100%;
        opacity: 0.25;
        transition: opacity 0.3s ease-in-out, filter 0.3s ease-in-out;
        transform:scale(.8);
    }
    }
    .slide-thumbnail {
      display: flex;
      justify-content: center;
      &.agile__slide--active {
        .bottle-image-container {
          img {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
      @include hover-focus {
        .bottle-image-container {
          img {
            transform:scale(.85);
            opacity: 1;
          }
        }
      }
    }

    .slide-thumbnail {
      cursor: pointer;
    }
  }

  //main carousel
  .main-carousel {
    display: flex;
    width: 100%;
    @include hover-focus {
      ::v-deep .agile__actions {
        opacity: 1;
      }
    }

    @include media-breakpoint-up(sm) {
      --main-nav-button-position: 2em;
    }

    @include media-breakpoint-up(lg) {
      --main-nav-button-position: -1em;
    }
  }

  //agile

  ::v-deep .agile--ssr {
    .agile__slides {
    }
    .agile__slides > * {
      min-width: 100%;
    }
  }

  ::v-deep .agile__actions {
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    top: 0;
    width: 100%;
    pointer-events: none;
    justify-content: space-between;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  ::v-deep .agile__nav-button {
    height: 3em;
    display: flex;
    align-content: space-between;
    all: unset;
    cursor: pointer;
    padding: 1em;
    z-index: 3;
    pointer-events: visible;
    transform: scale(1);
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    background: white;
    border-radius: 1em;
    box-shadow: 0px 0px 0px 2px rgba(0, 0, 0, 0.06);
  }

  ::v-deep .agile__actions {
    .agile__nav-button.agile__nav-button--prev {
      margin-left: var(--main-nav-button-position);
    }
    .agile__nav-button.agile__nav-button--next {
      margin-right: var(--main-nav-button-position);
    }
    .agile__nav-button .icon {
      width: 1.5em;
      height: 1.5em;
    }
    .agile__nav-button .icon .ls {
      stroke: var(--hero-arrow-color);
      stroke-width: 4px;
      stroke-linecap: round;
    }
  }
  </style>
